import React from "react";
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
} from "react-icons/fa";
import { useSettings } from "../context/settingContext";

const iconMap = {
    "fab fa-facebook-f": FaFacebookF,
    "fab fa-twitter": FaTwitter,
    "fab fa-instagram": FaInstagram,
    "fab fa-linkedin-in": FaLinkedinIn,
};

const SocialIcons = () => {
    const { settings } = useSettings();

    if (!settings?.social) {
        return (
            <div className="flex space-x-4 mt-4">
                {[...Array(4)].map((_, i) => (
                    <div
                        key={i}
                        className="w-[25px] h-[25px] rounded-full bg-gray-300 animate-pulse"
                    />
                ))}
            </div>
        );
    }

    return (
        <div className="flex space-x-4 mt-4">
            {settings.social.icons.map((icon, index) => {
                const IconComponent = iconMap[icon];
                return (
                    <a
                        key={index}
                        href={settings.social.links[index]}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {IconComponent && (
                            <IconComponent className="hover:text-white cursor-pointer text-black text-[25px]" />
                        )}
                    </a>
                );
            })}
        </div>
    );
};

export default SocialIcons;
